import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import { NotificationsController } from '@recruitee/user-interface';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandlerService {
  constructor(
    private notificationsCtrl: NotificationsController,
    private i18nService: I18nService,
  ) {}
  public default(errorResponse: HttpErrorResponse): void {
    return errorResponse.error && errorResponse.error.error && errorResponse.error.error.length
      ? errorResponse.error.error.forEach((message: string) => {
          this.notificationsCtrl.error(message);
        })
      : this.notificationsCtrl.error(this.i18nService.translate('rti.common.request_error'));
  }
}
